module.exports = __webpack_public_path__ + "static/media/page_19.b9e40b49.jpg";